<div class="content-wrapper flex flex-row flex-wrap">
  <div>{{ '+INSTALLATIONS.INSTALLATION.TRENDING.DATE_RANGE_TEXT_LABEL' | translate }}:</div>

  <div class="datepicker flex flex-row items-center">
    <mat-form-field appearance="fill">
      <mat-label>{{ '+GENERAL.DATEPICKER.DAY_PICKER' | translate }}</mat-label>

      <mat-date-range-input
        matDateRangePicker
        [formGroup]="dateRangeForm"
        [rangePicker]="picker"
        [min]="minRangepickerDate"
        [max]="maxRangepickerDate"
        data-at-rangepicker
      >
        <input readonly matStartDate matInput formControlName="start" fieldTextContentTooltip />
        <input readonly matEndDate matInput formControlName="end" fieldTextContentTooltip />
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>

      <mat-error
        data-at-rangepicker-error
        *ngIf="dateRangeForm.controls.start.hasError('matStartDateInvalid')"
        >{{ '+GENERAL.RANGEPICKER.ERROR.INVALID_START_DATE' | translate }}</mat-error
      >
      <mat-error
        data-at-rangepicker-error
        *ngIf="dateRangeForm.controls.end.hasError('matEndDateInvalid')"
        >{{ '+GENERAL.RANGEPICKER.ERROR.INVALID_END_DATE' | translate }}</mat-error
      >
    </mat-form-field>
    <button
      data-at-rangepicker-clear-btn
      class="rangepicker-clear-btn"
      *ngIf="dateRangeForm.value.end"
      mat-icon-button
      gtm="onClearSearch"
      gtmAction="Data trending date"
      gtmCategory="dataTrending"
      (click)="resetDateRange()"
      matTooltip="{{ '+GENERAL.RANGEPICKER.TOOLTIP.RESET_DATE' | translate }}"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-form-field mat-select-height-large class="resolution-picker">
    <mat-label>{{
      '+INSTALLATIONS.INSTALLATION.TRENDING.CHARTS.SELECT_RESOLUTION' | translate
    }}</mat-label>
    <mat-select
      data-at-resolution-select
      fieldTextContentTooltip
      (selectionChange)="resolutionChange($event)"
      [value]="selectedResolution"
    >
      <mat-option
        gtm="onSelect"
        gtmAction="Country"
        gtmCategory="gatewayCommissioningAddressForm"
        fieldTextContentTooltip
        [value]="resolution.value"
        *ngFor="let resolution of resolutions"
      >
        <span>{{ resolution.view | translate }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
